import Image from '@components/Image'
import Card from '@components/V3/Card'
import classnames from '@helpers/misc/classnames'
import useIsDarkMode from '@hooks/useIsDarkMode'
import useInitialData from '@page-components/Layout/useInitialData'
import Link from 'next/link'

export function Logo() {
  const initialData = useInitialData()
  const {website} = initialData
  const isDark = useIsDarkMode()

  if (!website) return null

  const logo = website.logo
  if (!logo) return null

  return <>
    <Card
      className={classnames({
        'w-full flex justify-center pt-4': true
      })}
      transparentOnDesktop
      desktopThreshold="lg">
      <div className=" dark:bg-white rounded-lg p-2">
        <div className="relative h-[100px] w-[150px]">
          <Link href="/">

            <Image
              priority
              src={logo.url}
              alt={website.name || 'Logo'}
              title={website.name || 'logo'}
              objectFit="contain"
              layout="fill"
            />

          </Link>
        </div>
      </div>
    </Card>
  </>;
}
